import { useConnectionQuery } from "@/apollo/types";

export function useConnection(id: string) {
  const { data: { connection } = {}, loading } = useConnectionQuery({
    variables: { id },
  });

  return { connection, loading };
}
